import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SupportedLanguage } from 'src/environments/environment.model';

import { LanguageDetectionService } from './language-detection.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageParamResolver implements Resolve<void> {
  private translateService = inject(TranslateService);
  private languageDetectionService = inject(LanguageDetectionService);

  public resolve(route: ActivatedRouteSnapshot): void {
    const param = route.queryParamMap.get('lang');
    // check for locale-like value
    const lang = param ? param.split('-')[0].toLowerCase() : null;
    const isSupported = environment.supportedLanguages.some((l: SupportedLanguage) => l.locale === lang);
    if (lang && isSupported) {
      // wait until language detection is completed
      this.languageDetectionService.languageDetectionComplete
        .pipe(
          filter((e) => e === true),
          take(1)
        )
        .subscribe(() => {
          this.translateService.use(lang);
        });
    }
  }
}
